import { render, staticRenderFns } from "./AppUnderDepartmentListBlock.vue?vue&type=template&id=023d9a08&scoped=true"
import script from "./AppUnderDepartmentListBlock.vue?vue&type=script&lang=js"
export * from "./AppUnderDepartmentListBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023d9a08",
  null
  
)

export default component.exports